import { render, staticRenderFns } from "./toSafesTransfers.vue?vue&type=template&id=cc4b0a0c"
import script from "./toSafesTransfers.vue?vue&type=script&lang=js"
export * from "./toSafesTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports